import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IOrderDetailResponse} from '../interfaces/services';

export const getSalesmanOrderDetail = async (
  id: string,
  token: string,
): Promise<IOrderDetailResponse> => {
  const remoteURI = remote.getSalesmanOrdersUri();
  return (await remoteCall(
    async () => {
      return await fetch(`${remoteURI}/${id}`, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;
          const {payload} = data;
          return {
            success,
            payload,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IOrderDetailResponse;
};
